<div style="width: 100%; height: 500px; position: relative; padding-bottom: 56.25%; text-align:left">
    <iframe [src]="safeUrl" frameborder="0" scrolling="auto" style="width: 100%; height: 100%; position: absolute;" allowfullscreen></iframe>
  </div>